import { useQuery } from "@tanstack/react-query";
import { fetchGETRequest } from "../utils/services";
import { MeterEventsV2Response } from "../types";

interface UseMeterEventsV2Props {
  meterSerialNumber: string;
  from: string;
  to: string;
  skip: number;
  take: number;
}

const fetchMeterEventsV2 = async ({
  meterSerialNumber,
  from,
  to,
  skip,
  take,
}: UseMeterEventsV2Props): Promise<MeterEventsV2Response> => {
  if (!meterSerialNumber) {
    return {
      success: false,
      message: "No meter serial number provided",
      data: { records: [], total: 0, hasMore: false, eventTypes: [] },
      errors: null,
    };
  }

  // API expects from/to in ISO format (YYYY-MM-DDTHH:mm)
  const response = await fetchGETRequest<MeterEventsV2Response>(
    `v2/meter-events/browse?skip=${skip}&take=${take}&search=${meterSerialNumber}&from=${from}&to=${to}`
  );

  return (
    response || {
      success: false,
      message: "Failed to fetch events",
      data: { records: [], total: 0, hasMore: false, eventTypes: [] },
      errors: null,
    }
  );
};

const useMeterEventsV2 = (props: UseMeterEventsV2Props) => {
  return useQuery({
    queryKey: [
      "meterEventsV2",
      props.meterSerialNumber,
      props.from,
      props.to,
      props.skip,
      props.take,
    ],
    queryFn: () => fetchMeterEventsV2(props),
    enabled: !!props.meterSerialNumber && !!props.from && !!props.to,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 1 * 60 * 1000, // 1 minute
  });
};

export default useMeterEventsV2;
